module.exports = __webpack_public_path__ + "media/images/business/trial/img_trial-234dbcfe98bd5b541a4d0d08f5006f60.jpg";